import React from 'react';

import phoneWhiteSvg from '../assets/svg/phone-white.svg';
import mapMarkerWhiteSvg from '../assets/svg/map-marker-white.svg';
import mailWhiteSvg from '../assets/svg/mail-white.svg';
import amaeFooterLogoSvg from '../assets/logos/amae-footer.svg';
import privacyStatementPDF from '../assets/pdf/198601AVISO-DE-PRIVACIDAD-PAGINA-WEB-GSEG.pdf';
import termsPDF from '../assets/pdf/198602CUSF-4-10.pdf';
import generalTermsPDF from '../assets/pdf/Condiciones-Generales-03.pdf';

const FooterContainer = () => {
  return (
    <div className="footer">
      <div className="information">
        <h2 className="text-center">
          ¿Tienes preguntas?
        </h2>
        <p className="text-center">
          Contáctanos en cualquiera de nuestros canales y con gusto te atenderemos.
        </p>
        <div className="info-row">
          <div className="icon">
            <img src={phoneWhiteSvg} alt="Teléfono AMAE" />
          </div>
          <div>
            Llámanos al
            <br />
            <strong>55 8869 3926</strong>
            <br />
            En un horario de 9:00 a 19:00 hrs. de lunes a viernes.
          </div>
        </div>
        <div className="info-row">
          <div className="icon">
            <img src={mailWhiteSvg} alt="Correo electrónico AMAE" />
          </div>
          <div>
            Escríbenos a
            <br />
            <strong>
              <a href="mailto:amae_ventas@gsalud.com.mx" target="_blank" rel="noreferrer">
                amae_ventas@gsalud.com.mx
              </a>
            </strong>
            <br />
            Nos pondremos en contacto contigo lo antes posible.
          </div>
        </div>
      </div>

      <div className="contact">
        <img className="amae-logo" src={amaeFooterLogoSvg} alt="AMAE Seguro" />
        <div className="info-row">
          <div className="icon">
            <img src={mapMarkerWhiteSvg} alt="Dirección" />
          </div>
          <div>
            Patriotismo 266, Col. San Pedro de los Pinos, Código Postal 03800, Benito Juárez, CDMX
          </div>
        </div>
        <div className="info-row">
          <div className="icon">
            <img src={phoneWhiteSvg} alt="Teléfono AMAE" />
          </div>
          <div>
            <a href="tel:8004000437">
              800 400 0437
            </a>
          </div>
        </div>
        <div className="info-row">
          <div className="icon">
            <img src={mailWhiteSvg} alt="Correo electrónico" />
          </div>
          <div>
            <a target="_blank" rel="noreferrer" href="mailto:atencionaclientes@gseguros.com.mx">
              atencionaclientes@gseguros.com.mx
            </a>
          </div>
        </div>
        <h3>Enlaces útiles</h3>
        <p>
          <a href={privacyStatementPDF} rel="noreferrer" target="_blank">Aviso de Privacidad</a>
        </p>
        <p>
          <a href={termsPDF} rel="noreferrer" target="_blank">Términos y condiciones</a>
        </p>
        <p>
          <a href={generalTermsPDF} rel="noreferrer" target="_blank">Condiciones generales</a>
        </p>
        <hr />
        <p className="text-center">AMAE® 2022. Todos los derechos reservados.</p>
      </div>
    </div>
  );
};

export default FooterContainer;
